import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { authGuard } from './shared/auth.guard';
import { LoginComponent } from './authentication/login/login.component';
import { ModuleComponent } from './layouts/module/module.component';
import { NotfoundComponent } from './authentication/404/not-found.component';
import { CertDesgravComponent } from './pages/cert-desgrav/cert-desgrav.component';
import { roleGuard } from './core/guards/role.guard';
import { NotAuthorizedComponent } from './authentication/not-authorized/not-authorized.component';


export const Approutes: Routes = [

  {
    path: 'login',
    component: LoginComponent
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '',
    component: FullComponent,
    canActivate: [],
    children: [
      { path: '', redirectTo: '/admin', pathMatch: 'full' },
      {
        path: 'admin',
        canActivate: [roleGuard],           
        data: { roles: ['admin'] },
        loadChildren: () =>
          import('./pages/projects/projects.routing')
      },
    ],
  },

  {
    path: 'administration',
    component: ModuleComponent,
    canActivate: [ roleGuard],    
    data: { roles: ['admin'] },
    loadChildren: () =>
      import('./pages/administration/administration-routing')
  },

  {
    path: 'sales',
    canActivate: [ roleGuard],     
    data: { roles: ['sales'] },
    loadChildren: () =>
      import('./pages/sales/sales.module').then(
        (m) => m.SalesModule
      ),
  },


  {
    path: 'starter',
    component: ModuleComponent,
    canActivate: [roleGuard],
    data: { roles: ['admin'] },
    loadChildren: () =>
      import('./starter/starter.routing')
  },

  {
    path: 'authentication',
    component: BlankComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },

  {
    path: 'cert-desgrav/:id',
    component: CertDesgravComponent,
  },
  {
    path: 'no-autorizado',
    component: NotAuthorizedComponent,
  },

  {
    path: '**',
    component: NotfoundComponent,
  },
];
